import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DoorOffsetCalculatorService {
  /**
   * Retourne la valeur CSS `margin-left` pour le recouvrement coulissant.
   */
  calculateOffset(door, doorNumber: number, doorHtmlElement: HTMLElement): number {
    if (!door?.layer?.percentOffsetIfOverlay || !doorNumber || doorHtmlElement.offsetWidth <= 0) return 0;
    // On calcule le recouvrement de la porte en appliquant le pourcentage de recouvrement sur la largeur du vantail affiché dans l'écran
    return (doorHtmlElement.offsetWidth * door.layer.percentOffsetIfOverlay) / 100;
  }
}
